import { Text } from '@vds/core';
import React, { useEffect, useState } from "react"
import { Badge } from '@vbg-ds/core';

const CountDown=({toDate,fromPDP=false,setDisableButton=()=>{},preceedingText=""})=>{
    const [remainingDate,setRemainingDate] = useState(undefined)
    const [remainingHours,setRemainingHours] = useState(undefined)
    const [remainingMinutes,setRemainingMinutes] = useState(undefined)
    const [remainingSeconds,setRemainingSeconds] = useState(undefined)

    useEffect(()=>{
        const setInter = setInterval(()=>{
            calcRemainingTime()
            if(toDate < new Date()) clearInterval(setInter)
        },1000)
        if(fromPDP){
            const disableInterval = setInterval(()=>{
            if(toDate > new Date()){
                setDisableButton(true)
            }else{
                clearInterval(disableInterval)
                setDisableButton(false)
            }
        },20000)
        disableTime()
        }
        
        
    },[])
    const disableTime = ()=>{
        if(toDate > new Date()){
            setDisableButton(true)
        }else{
            setDisableButton(false)
        }
    }
    const calcRemainingTime = ()=>{
        const remainingTimeFrame = toDate - new Date()
        if(toDate > new Date()){
        const TotalRemaingTime = String((remainingTimeFrame / (24*60*60*1000))).split('.')
        setRemainingDate(Number(TotalRemaingTime[0]))
        if(TotalRemaingTime.length > 1){
            const hoursRem = String((Number(('0.'+TotalRemaingTime[1])) * 24)).split('.')
            setRemainingHours( Number(hoursRem[0]))
            if(hoursRem.length > 1){
                const minutesRem = String((Number(('0.'+hoursRem[1])) * 60)).split('.')
                setRemainingMinutes(Number(minutesRem[0]))
                if(minutesRem.length > 1){
                    const seconds = String((Number(('0.'+minutesRem[1])) * 60)).split('.')
                    const secondsFinal = Number(seconds[0])
                    setRemainingSeconds(secondsFinal)
                }
            }
        }
    }
    }
    if( toDate > new Date() && remainingDate !== undefined && remainingDate !== null && remainingHours !== undefined && remainingHours !==null && remainingMinutes !== undefined && remainingMinutes !== null && remainingSeconds !== undefined && remainingSeconds !== null){
        if(fromPDP){
        return (<Badge  backgroundColor="neonYellow">{preceedingText}{`${remainingDate ? remainingDate+' day(s)' : ''} ${(remainingDate <1 && remainingHours < 1) ? '' : (remainingHours + 'h :')} ${(remainingDate <1 && remainingHours < 1 && remainingMinutes < 1) ? '' : (remainingMinutes + 'm :')} ${remainingSeconds}s`}</Badge>)
        }else
       return (
         <Badge  backgroundColor="neonYellow">{preceedingText}{`${remainingDate ? remainingDate+' day(s)' : ''} ${(remainingDate <1 && remainingHours < 1) ? '' : (remainingHours + 'h :')} ${(remainingDate <1 && remainingHours < 1 && remainingMinutes < 1) ? '' : (remainingMinutes + 'm :')} ${remainingSeconds}s`}</Badge> 
       )
    }
    return <></>
}

export default CountDown